/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Dashboard
 * (C) Copyright IBM Corp. 2013, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'jquery',
	'underscore',
	'./Toolbar',
	'./Labels',
	'./CustomTooltip',
	'./interaction/Utils',
	'../utils/Flyout',
	'../nls/StringResources',
	'../utils/DialogBlocker'
], function($, _, Toolbar, Labels, CustomTooltip, utils, Flyout, resources, DialogBlocker) {
	var AuthoringToolbar = null;
	const localFilterClassName = 'localFilterViewWrapper';
	const localFilterClass = `.${localFilterClassName}`;

	AuthoringToolbar = Toolbar.extend({

		baseClass: 'toolbar authoringToolbar',

		/**
		 * Create a contextual toolbar. The options is passed to flyout control constructor.
		 *
		 * @param options
		 */
		init: function(options) {
			this.options = options;
			AuthoringToolbar.inherited('init', this, arguments);
			this.$el.addClass(this.baseClass);
			this.id = _.uniqueId('authtb_');
			this.selectionNodes = [];
			this._viewStack = [];
			this._savedItemSpecs = [];
			this.isOpened = false;
			this._labelsView = null;
			this._labelsAsActionView = null; //Placeholder of labels only menu items, such as showBy
		},

		_addLabelsView_asAction: function($item){
			if (this._labelsAsActionView) {
				this._labelsAsActionView.remove();
			}
			this._labelsAsActionView = $('<div class="labelsAsActionToolBar"></div>');
			this._labelsAsActionView.prepend($item);
		},

		_renderCaptionButton: function($caption, icon, labelId, floatPosition, callback) {
			$caption.addClass('caption');//Normal NextView Caption that enables GoToPrevious/Close
			var $back = $(`<span class="${icon}" tabindex="0" style="float:${floatPosition}"></span>`);
			$back.attr({
				'aria-label': resources.get(labelId)
			});
			$caption.addClass('child');
			$caption.prepend($back);
			$caption.on('primaryaction', callback);
		},

		closeFlyout: function() {
			if (this.closeButtonEnabled) {
				this.hide(1);
			} else if (this.goToPreviousEnabled !== false) {
				this.showPreviousView();
			}
		},

		/**
		 * Return the html that will be placed in the flyout. We only include the toolbar container in this html.
		 * The actual toolbar content is placed once the flyout is shown.
		 * @returns {String}
		 */
		getRenderedHtml: function() {
			var $content;
			if (this.options.textOnly) {
				$content = $('<div class="toolbarTextPopoverContent"></div>');
			} else {
				$content = $('<div class="toolbarPopoverContent"></div>');
			}

			$content.attr({
				'role': 'region',
				'aria-label': this.name || resources.get('toolbarRegionLabel')
			});

			if (this.name && this.showCaption) {
				var $name = $('<h1>').text(this.name);//Catpion placeholder
				if (this.closeButtonEnabled) {
					this._renderCaptionButton($name, 'wfg_shape_x', 'dlg_close', 'right', this.hide.bind(this));
				} else if(this.goToPreviousEnabled !== false){
					$name.addClass('caption');//Normal NextView Caption that enables GoToPrevious
					if (this.options.launchView || this._viewStack.length) {
						this._renderCaptionButton($name, 'wfg_leftarrow', 'dlg_back', 'left', this.showPreviousView.bind(this));
					}
				} else {
					$name.addClass('staticNextViewCaption');//Render with GoToPrevious
				}
				$content.append($name);
			}

			if (this._labelsView) {
				if (!this.itemMap.subview) {
					$content.append(this._labelsView.$el);
				}
			}

			if(this._labelsAsActionView){
				$content.append(this._labelsAsActionView);
			}

			var lengthKeys = Object.getOwnPropertyNames(this.itemMap).length;
			if (lengthKeys > 0) {
				if (this._labelsView && !this.options.isTextEditorOnly) {
					$content.append('<div class="separator"></div>');
				}

				if(this.$el.hasClass('textOnlyToolBar')){
					this.$el.removeClass('textOnlyToolBar');
				}

				// we have actions
				$content.append(this.$el);

				if (this.name && lengthKeys > 1) {
					// allow the toolbar to grow up to 50% wider in order to accommodate long captions with reasonable space
					// captions beyond this size shall be truncated (text-overflow: ellipsis)
					$content.css('max-width', lengthKeys * 47 * 1.5 + 'px');
				}
			}

			if (this.options.isTextEditorOnly) {
				if (this._labelsView) {
					this._labelsView.$el.addClass('textOnlyToolBar');
				}
				this.$el.addClass('textOnlyToolBar');
			}

			return $content;
		},

		setFocus: function() {
			if (this.itemMap.subview && this.itemMap.subview.subView.setFocus) {
				this.itemMap.subview.subView.setFocus();
			} else if (!this.options.noFocus) {
				AuthoringToolbar.inherited('setFocus', this, arguments);
			}
		},

		setLabels: function(options) {
			if (this._labelsView) {
				this._labelsView.remove();
				this._labelsView = null;
			}
			if (options.tooltipRenderer && options.tooltipContext && options.tooltipRenderer.canRender(options.tooltipContext) ){
				this._labelsView = new CustomTooltip(options.tooltipRenderer, options.tooltipContext);
				this._labelsView.render();
			} else if ((options.labels || options.title)) {
				this._labelsView = new Labels(options);
				this._labelsView.render();
			}
		},

		setName: function(sName) {
			this.name = sName || null;
		},

		setShowCaption: function(showCaption) {
			this.showCaption = showCaption;
		},

		/**
		* @param {Boolean} Enabled,  enable or disable GoToPrevious buton
		* By default, true.
		**/
		enableGoPrevious: function(enabled) {
			this.goToPreviousEnabled = enabled !== false ? true : false;
		},

		enableClose: function(enabled) {
			this.closeButtonEnabled = !!enabled;
		},

		focusGoPrevious: function() {
			if (this.goToPreviousEnabled) {
				this.$el.prev().find('*[tabindex=0]').first().focus();
			}
		},

		setOptions: function(options) {
			this._options = options;
			// Allow implementer to update options and add ele class
			// options = { addClass: ['classToAdd', 'classToAdd2'] }
			if (options && options.addClass) {
				if (typeof options.addClass == 'string') {
					this.$el.addClass(options.addClass);
				} else {
					this.$el.addClass(options.addClass.join(' '));
				}
			}
		},

		/**
		 * Called when the flyout is shown.
		 */
		onPopupShown: function() {
			this.isOpened = true;
			if (this.$boundingRectNode) {
				this.$boundingRectNode.css('display', 'none');
			}

			this.trigger('toolbar:show', this._options);
		},

		/**
		 * Called when the flyout is closed.
		 */
		onPopupClosed: function() {
			// need to call hide if the popup (flyout) was closed, but not the toolbar
			const promise = this.isOpened ? this.hide() : Promise.resolve();
			promise.then(() => {
				this.trigger('toolbar:hide', this._options);
			});
		},

		/**
		 * Set the selected nodes. This will be used to calculate where to show the toolbar flyout.
		 *
		 * @param nodes
		 */
		setSelectionContext: function(nodes) {
			let promise;

			// If we changed the selected nodes, we set the flag isReposition to true to indicate that we want to reposition to toolbar when we show it.
			// This flag is used to minimize the repositioning of the toolbar when repositioning is not needed.
			var unionLength = _.union(this.selectionNodes, nodes).length;
			if (!this.selectionNodes
				|| unionLength !== nodes.length
				|| unionLength !== this.selectionNodes.length
				|| this.lastPositionKey !== this.getPositionKey(nodes)) {
				// AuthoringToolbar context has changed . Cleanup existing flyout.
				promise = this._destroyFlyout();
			}

			this.launchPoint = this._getSelector($(nodes).last());
			if (this.options.launchView && this.options.launchView.getFlyout) {
				this.launchPoint = this.options.launchView.getFlyout().getLaunchPoint();
			}
			this.lastPositionKey = this.getPositionKey();
			this.selectionNodes = nodes.slice();
			this.selectionBounds = null;

			return promise || Promise.resolve();
		},

		_getSelector: function($el) {
			var selector, $currentNode = $el;
			while ($currentNode.length) {
				var node = $currentNode[0],
					name = node.localName;
				if (!name) {
					break;
				}
				name = name.toLowerCase();
				var $parent = $currentNode.parent();
				var $siblings = $parent.children(name);
				if ($siblings.length > 1) {
					name += ':eq(' + $siblings.index(node) + ')';
				}
				selector = name + (selector ? '>' + selector : '');
				$currentNode = $parent;
			}

			return selector;
		},

		getPositionKey: function(nodes) {
			var getPos = function(node) {
				return [node.offsetTop, node.offsetLeft, node.offsetWidth, node.offsetHeight].join('_');
			};
			return _.map(nodes || this.selectionNodes, getPos).sort().join('_');
		},

		/**
		 * Set the selected nodes. This will be used to calculate where to show the toolbar flyout.
		 *
		 * @param nodes
		 */
		setSelectionBounds: function(bounds) {
			// AuthoringToolbar context has changed . Cleanup existing flyout.
			let promise = this._destroyFlyout();

			this.selectionBounds = bounds;
			this.selectionNodes = [];

			return promise;
		},

		/**
		 * Draw a div around the selected nodes so that we can properly place the popover.
		 *
		 */
		_getFlyoutNode: function() {
			if (this.options.triggerNode) {
				return this.options.triggerNode;
			} else if (this.selectionNodes.length > 1 || this.selectionBounds || this.options.calculateBoundingRect) {
				if (!this.$boundingRectNode) {
					const topLeft = this.getSelectionBounds();
					let top = topLeft.minTop;
					let left = topLeft.minLeft;
					const fullScreenElement = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement;
					if (topLeft.parent && topLeft.parent != fullScreenElement) {
						let offset = $(topLeft.parent).offset();
						top += offset.top;
						left += offset.left;
					}
					this.$boundingRectNode = $('<div class="widgetContextNode"></div>');
					let height = Math.round(topLeft.maxTop - topLeft.minTop);
					const width = Math.round(topLeft.maxLeft - topLeft.minLeft);
					top = Math.round(top);
					left = Math.round(left);

					//hacky, but since this is added to 'body' and is absolutely positioned,
					// we have to make sure to not overflow so ensure
					// the height is less than #main's height - top.
					const $main = $('#main');
					if ($main.length) {
						const mainHeight = $main.height() - top;
						height = Math.min(height, mainHeight);
					}

					this.$boundingRectNode.css({
						'position': 'absolute',
						'top': top + 'px',
						'left': left + 'px',
						'height': height + 'px',
						'width': width + 'px'
					});

					this.$boundingRectNode.appendTo('body');

					this.applyDimensionsForBestLocation(topLeft, this.$boundingRectNode);
				}
				return this.$boundingRectNode[0];
			} else if (this.selectionNodes.length === 1) {
				return this.selectionNodes[0];
			}
		},

		/**
		 * Apply the best dimensions for the popover node that will result in the best location for the contextual toolbar.
		 * If the node is rotated, the contextual toolbar will be displayed using the bounding client rect of the popover node which might be too wide or too narrow.
		 * This might cause the toolbar to appear closer to other items and it might be confusing.
		 *
		 * This method will detect if there is a rotation and will try to find the biggest square that fits inside the popover node and the best location of that square within the popover node and then use the square as popover node.
		 *
		 * @param bounds
		 * @param $element
		 */
		applyDimensionsForBestLocation: function(bounds, $element) {
			var width = Math.round(bounds.maxLeft - bounds.minLeft);
			var height = Math.round(bounds.maxTop - bounds.minTop);
			var size = Math.min(width, height);

			// The bounding client rect height or width are bigger than the node height and width
			// This means that the node is rotated.
			var boundingRect = $element[0].getBoundingClientRect();
			if (Math.round(boundingRect.width) > width || Math.round(boundingRect.height) > height) {
				// Resize the node to the largest square that can fit in the original size and position it at the top left.
				$element.css({
					'top': bounds.minTop + 'px',
					'left': bounds.minLeft + 'px',
					'height': size + 'px',
					'width': size + 'px'
				});

				// If the new bounding client rect is lower than the original one, we move the square to the bottom right
				// This prevents the toolbar to be displayed on top of the element associated with it.
				var newBoundingRect = $element[0].getBoundingClientRect();
				if (Math.round(newBoundingRect.top) > Math.round(boundingRect.top)) {
					$element.css({
						'top': bounds.maxTop - size + 'px',
						'left': bounds.maxLeft - size + 'px',
						'height': size + 'px',
						'width': size + 'px'
					});
				}
			}

			// restrict the bounding box to the viewable area (i.e. parent)
			if (this.selectionNodes && this.selectionNodes.length > 0) {
				// grab the parent node of the first element
				var parent = this.selectionNodes[0].parentNode;
				if (parent && parent.getBoundingClientRect) {
					// get the bounding rectangle of the parent and compare to current
					var parentBoundingRect = parent.getBoundingClientRect();
					boundingRect = $element[0].getBoundingClientRect();

					// restrict to the parent's limits
					var top = Math.max(boundingRect.top, parentBoundingRect.top);
					var bottom = Math.min(boundingRect.bottom, parentBoundingRect.bottom);
					var left = Math.max(boundingRect.left, parentBoundingRect.left);
					var right = Math.min(boundingRect.right, parentBoundingRect.right);
					$element.css({
						'top': top + 'px',
						'left': left + 'px',
						'height': (bottom - top) + 'px',
						'width': (right - left) + 'px'
					});
				}
			}
		},

		getSelectionBounds: function() {
			var bounds;
			if (this.selectionBounds) {
				bounds = {
					minTop: this.selectionBounds.top,
					minLeft: this.selectionBounds.left,
					maxTop: this.selectionBounds.top + this.selectionBounds.height,
					maxLeft: this.selectionBounds.left + this.selectionBounds.width,
					parent: this.selectionBounds.parent
				};
			} else {
				bounds = utils.getMinMaxTopLeft(this.selectionNodes, (n) => {
					var $n = $(n);
					var position = $n.offset();

					var heightOverflow = (n.scrollHeight - n.clientHeight);
					var widthOverflow = (n.scrollWidth - n.clientWidth);

					position.top -= heightOverflow / 2;
					position.left -= widthOverflow / 2;
					var rect = n.getBoundingClientRect();
					position.height = Math.max(rect.height, rect.height + heightOverflow);
					position.width = Math.max(rect.width, rect.width + widthOverflow);
					return position;
				});
			}

			return bounds;
		},

		pushItemsOnStack: function() {
			this._viewStack.push({
				name: this.name,
				items: this._savedItemSpecs
			});
			this._savedItemSpecs = [];
		},

		showPreviousView: function() {
			if (this._viewStack.length) {
				var savedInfo = this._viewStack.pop();

				return this.hide(1)
					.then(() => {
						this.clearItems();
						this.setName(savedInfo.name);
					})
					.then(this.addItems.bind(this, savedInfo.items))
					.then(this.show.bind(this, this.placement));
			} else if (this.options.launchView && this.options.backButtonCallback) {
				this.flyout.destroy();
				this.options.backButtonCallback.apply(this.options.launchView);
			}

			return Promise.resolve();
		},

		clearHistory: function() {
			this._viewStack = [];
		},

		clearItems: function() {
			this._savedItemSpecs = [];
			if (this._labelsAsActionView) {
				this._labelsAsActionView.remove();
				this._labelsAsActionView = null;
			}

			AuthoringToolbar.inherited('clearItems', this, arguments);
		},

		/**
		 * Show the toolbar as a flyout. The flyout will be positions around the selected nodes
		 *
		 * @param placement (optional) Used when we want to force the placement to a specify position. Only used for sub views in a toolbar.
		 */
		show: function(placement) {
			var node = this._getFlyoutNode();
			if (node) {
				// Create a flyout if we don't have one.
				this._createFlyout(node, placement || this.options.placement);

				return this.ready()
					.then(() => {
						// Block ODT from appearing over the widget authoring panel view
						let odtEdgeCase = this._options && this._options.isWidgetOdt && DialogBlocker.isShowingDialogBlocker();
						// Only show the flyout if it is not open. This is to avoid flickering when clicking on a selected widget
						if (this.flyout && !this.isOpened && !odtEdgeCase) {
							if (this.$boundingRectNode) {
								this.$boundingRectNode.css('display', 'block');
							}
							this.trigger('toolbar:show:before', this._options);

							return this.flyout.open(node)
								.then(() => {
									this.notifyItemsOpened();
								});
						}
					});
			}
			return Promise.reject();
		},

		/**
		 * Create the Flyout wrapper (contaier with the arrow) for the toolbar.
		 * @param node
		 * @param placement (Optional) If passed in, we don't compute the placement. Used to prevent toolbar from jumping around when a sub view is presented in the toolbar.
		 */
		_createFlyout: function(node, placement) {
			if (!this.flyout) {
				const topParentRect = $(this._getTopParentNode()).get(0).getBoundingClientRect();
				placement = placement || this._getPlacement(node, topParentRect, placement);

				var options = _.extend({
					selector: node,
					viewInstance: this,
					popoverClass: this._getPopoverClass(placement),
					placement: placement,
					alignment: this._getAlignment(placement),
					hideOnMouseLeave: this.options.hideOnMouseLeave === true,
					relatedNodes: this.selectionNodes,
					launchPoint: this.launchPoint
				}, this.options);

				// overwrite placement for cases where we have a localfilterview that wont fit in screen
				if (this.options && this.options.popoverContentClass === localFilterClassName) {
					options.placement = placement;
				}
				if (this.options && this.options.triggerNode) {
					options.notCentered = true;
				}

				this.flyout = new Flyout(options);

				if (!this.launchPoint) {
					// Capture the original launchPoint
					this.launchPoint = this.flyout.getLaunchPoint();
				}

				if (this.options.launchView && this.options.launchView.setFlyout) {
					this.options.launchView.setFlyout(this.flyout);
				}
			}
		},

		/**
		 * Get the content dimensions. This is used to properly calculate the placement of the toolbar.
		 */
		getContentDimensions: function() {
			var popoverClass = 'popover actionToolbarPopover';

			if (this.options.preferredVertical) {
				popoverClass += ' vertical';
			}

			function sHtml(cls) {
				// set the display to inline block to accurately get the width and height of the content
				return `<div class="${cls}" style="display:inline-block"></div>`;
			}

			let $content = $(sHtml(popoverClass)).appendTo('body');

			if (this._labelsView) {
				$content.append(this._labelsView.$el);
			}
			if (this._labelsAsActionView) {
				$content.append(this._labelsAsActionView);
			}
			$content.append(this.$el);

			// get popoverContentClass for correct content sizing
			// Sometimes contentClass is found in savedItemspecs
			if (!this.options.popoverContentClass && (this._savedItemSpecs && this._savedItemSpecs.length > 0)) {
				_.each(this._savedItemSpecs, (item) => {
					if (item.subView && item.subView.$el && item.subView.$el.hasClass(localFilterClassName)) {
						this.options.popoverContentClass = localFilterClassName;
					}
				});
			}

			if (this.options.popoverContentClass && !this.$el.find(localFilterClass).length > 0) {
				// pass in the content in the popover, otherwise we may get visual overflow bugs
				// Where the popover runs past the lower app boundary
				// Defect #205657, #208527; 226441; APAR #123258;
				let $popoverContent = $(sHtml(this.options.popoverContentClass));
				$content.append($popoverContent);
			}
			var d = {
				w: $content.outerWidth(),
				h: $content.outerHeight()
			};
			this.$el.detach();
			if (this._labelsView) {
				this._labelsView.$el.detach();
			}
			if (this._labelsAsActionView) {
				this._labelsAsActionView.detach();
			}
			$content.remove();
			return d;
		},

		/**
		 * Get the preferred placement of the toolbar .
		 * By default, it shows on top. If the the right half side is off screen, we try to show it to the left.
		 * If there is not space available at the top, we try to show it at the bottom.
		 *
		 * @param node
		 * @returns {String}
		 */
		_getPlacement: function(node, topParentRect, suggestedPlacement) {
			const dimensions = this.getContentDimensions(),
				rect = $(node).get(0).getBoundingClientRect();

			let {
				w: toolbarWidth,
				h: toolbarHeight
			} = dimensions;

			_.each(this._savedItemSpecs, (item) => {
				if (item.viewOptions) {
					toolbarWidth = !isNaN(item.viewOptions.width) ? Math.max(item.viewOptions.width, toolbarWidth) : toolbarWidth;
					toolbarHeight = !isNaN(item.viewOptions.height) ? Math.max(item.viewOptions.height, toolbarHeight) : toolbarHeight;
				}
			});
			const _checkSpaceToBottomForVerticalODT = () => {
				if (this._options && this._options.isWidgetOdt) {
					return (rect.top + toolbarHeight) < topParentRect.bottom;
				} else {
					return true;
				}
			};
			const _checkForSpaceInLocalFilterCase = () => {
				if (this.options && this.options.popoverContentClass &&
					this.options.popoverContentClass === localFilterClassName) {
					suggestedPlacement = suggestedPlacement || 'right';
					let spaceToBottom = window.innerHeight - (rect.bottom + rect.height);
					return spaceToBottom < toolbarHeight;
				}
				return false;
			};
			// Default placement is the top as the bottom can be obstructed by the "bottom pane" which isn't included
			// in this hierarchy for calculations.
			let placement = 'top';
			// Sometimes popover will overrun lower boundary of app, re-place to top in that case
			// We only take action on non odt popovers in authoring view i.e the localFilterViewWrapper
			if (_checkForSpaceInLocalFilterCase()) {
				// keep placement = top
			} else if (suggestedPlacement) {
				// No popoverContentClass == localFilter found, reset to suggestion if given
				placement = suggestedPlacement;
			} else if ((rect.left - toolbarWidth) > 0 && _checkSpaceToBottomForVerticalODT()) {
				// Give priority to the left because the right half of the widget is off screen & top doesnt work
				placement = 'left auto';
			} else if ((rect.left + rect.width + toolbarWidth - topParentRect.left) < topParentRect.width && _checkSpaceToBottomForVerticalODT()) {
				// check if there's room on the right
				placement = 'right auto';
			}
			this.placement = placement;
			return placement;
		},

		_getPopoverClass: function(placement) {
			var popoverClass = 'actionToolbarPopover';
			if (this.options.preferredVertical && placement !== 'top') {
				return `${popoverClass} vertical`;
			} else if (this.options.preferredVertical) {
				// preferredVertical but there was no room on left or right
				return `${popoverClass} horizontal`;
			} else {
				return popoverClass;
			}
		},

		_getAlignment: function(placement) {
			if (this.options.preferredVertical && placement !== 'top') {
				return 'top';
			} else if (this.options.preferredVertical) {
				return 'left';
			} else {
				return null;
			}
		},

		_getTopParentNode: function() {
			// If the toolbar is above the top level page, we will try to show it at the bottom
			var $parents = $(this.selectionNodes[0]).parents('.page');
			return $parents.get(-1) || $('body')[0];
		},

		/**
		 * Hide the flyout
		 */
		hide: function(bKeepStack) {
			this._savedItemSpecs = [];
			return this._destroyFlyout(bKeepStack);
		},

		/**
		 * In bootstrap, popover will overwrite the triggerNode's title value to empty string for disabling tooltips while flyout is open.
		 * Restore the title value for the triggerNode once the flyout is destroyed.
		 */
		_restoreTitle() {
			const $triggerNode = this.options && this.options.triggerNode && $(this.options.triggerNode);
			if ($triggerNode) {
				const title = $triggerNode.attr('title') || $triggerNode.attr('data-original-title') || '';
				$triggerNode.attr('title', title);
			}
		},

		/**
		 * Destroy the flyout
		 */
		_destroyFlyout: function(bKeepStack) {
			let promise;

			var destroyNode = () => {
				if (this.$boundingRectNode) {
					this.$boundingRectNode.remove();
					this.$boundingRectNode = null;
				}
			};

			this.isOpened = false;
			this.launchPoint = null;

			this.notifyItemsDestroyFlyout();
			if (this.flyout) {
				promise = this.flyout.destroy()
					.then(destroyNode);

				this.flyout = null;
			} else {
				destroyNode();
			}

			if (!bKeepStack) {
				this.clearHistory();
			}

			return promise || Promise.resolve();
		},

		/**
		 * Notifies all toolbar items that the flyout is opened.
		 * This is required by items that need to perform an action when the flyout is opened.
		 */
		notifyItemsOpened: function() {
			_.each(this.itemMap, (item) => {
				if (item.notifyRenderComplete) {
					item.notifyRenderComplete();
				}
			});
		},

		/**
		 * Notifies all toolbar items that the flyout has been destoryed.
		 * This is required by items that are not removed but would like to
		 * perform an action when the flyout is destroyed.
		 */
		notifyItemsDestroyFlyout: function() {
			this._restoreTitle();
			_.each(this.itemMap, (item) => {
				if (item.onFlyoutDestroyed) {
					item.onFlyoutDestroyed();
				}
			});
		},

		/**
		 * Add the item to the toolbar.
		 * If the itemSpec has specified 'closeOnActionApplied', override its action
		 * to point to a local method that calls its original action, then closes the toolbar.
		 * @param itemSpec The itemSpec for the Button/Label etc.
		 */
		addItem: function(itemSpec) {
			this._updateActionHandler(itemSpec);
			if (this._isLabelOnly(itemSpec)) {
				return this._addLabelOnlyItem(itemSpec);
			}

			return AuthoringToolbar.inherited('addItem', this, arguments);
		},

		/**
		 * Add the items to the toolbar.
		 * Save the itemSpecs
		 * @param itemSpec The itemSpec for the Button/Label etc.
		 */
		addItems: function(itemSpecs = []) {
			this._savedItemSpecs = itemSpecs;
			const toolBarItems = [];
			const addPromises = [];

			itemSpecs.forEach((itemSpec) => {
				this._updateActionHandler(itemSpec);
				if (this._isLabelOnly(itemSpec)) {
					addPromises.push(this._addLabelOnlyItem(itemSpec));
				} else {
					toolBarItems.push(itemSpec);
				}
			});
			addPromises.push(AuthoringToolbar.inherited('addItems', this, [toolBarItems]));

			return Promise.all(addPromises);
		},

		_addLabelOnlyItem: function(itemSpec) {
			const $item = $('<div>');
			this._addLabelsView_asAction($item);
			return this._renderItem(itemSpec, $item);
		},

		_isLabelOnly: function(itemSpec) {
			return itemSpec.labelOnly;
		},

		_updateActionHandler: function(itemSpec) {
			if (itemSpec.closeOnActionApplied) {
				if (itemSpec.action) {
					itemSpec.action = this._applyActionThenClose.bind(this, itemSpec.action);
				}
				if (itemSpec.actions) {
					itemSpec.actions.apply = this._applyActionThenClose.bind(this, itemSpec.actions.apply);
				}
			}
			if (itemSpec.removeOnActionApplied) {
				if (itemSpec.action) {
					itemSpec.action = this._applyActionThenRemove.bind(this, itemSpec.action);
				}
				if (itemSpec.actions) {
					itemSpec.actions.apply = this._applyActionThenRemove.bind(this, itemSpec.actions.apply);
				}
			}
			if (itemSpec.removeThenApplyAction) {
				if (itemSpec.action) {
					itemSpec.action = this._removeThenApplyAction.bind(this, itemSpec.action);
				}
				if (itemSpec.actions) {
					itemSpec.actions.apply = this._removeThenApplyAction.bind(this, itemSpec.actions.apply);
				}
			}
		},

		/**
		 * When the item spec contains 'closeOnActionApplied', this function is
		 * called to perform the original action specified, then close the toolbar.
		 */
		_applyActionThenClose: function(fnOriginalAction) {
			let args = [...arguments];
			fnOriginalAction.apply(this, args.shift());
			this.hide();
		},

		/**
		 * When the item spec contains 'removeOnActionApplied', this function is
		 * called to perform the original action specified, then close the toolbar.
		 */
		_applyActionThenRemove: function(fnOriginalAction) {
			let args = [...arguments];
			fnOriginalAction.apply(this, args.shift());
			this.remove(true);
		},

		/**
		 * When the item spec contains 'removeThenApplyAction', the toolbar is first
		 closed, then function is called to perform the original action specified.
		 */
		_removeThenApplyAction: function(fnOriginalAction) {
			this.remove(true);
			let args = [...arguments];
			fnOriginalAction.apply(this, args.shift());
		},

		/**
		 * Remove/destroy the toolbar and the objects associated with it.
		 *
		 */
		remove: function(triggerEvent) {
			this.clearItems();
			this._destroyFlyout().then(() => {
				if (triggerEvent) {
					this.trigger('toolbar:remove', this._options);
				}
				AuthoringToolbar.inherited('remove', this, arguments);
			});
		},

		/**
		 * This function sets focus on the first button in the toolbar
		 * @return Boolean - True if successful, false if not
		 */
		focus: function() {
			// if open then set focus on first button
			if (this.isOpened) {
				var aoButtons = $(this.el).find('button');
				if (aoButtons.length > 0) {
					aoButtons[0].focus();
					return true;
				}
			}
			return false;
		},

		updateButtons: function() {
			if (this.itemMap) {
				_.each(this.itemMap, (item) => {
					if (item.update) {
						item.render();
					}
				});
			}
		}

	});
	return AuthoringToolbar;
});
